/**
 * Currency display format configuration
 * Specifies which display format to use for each currency in CurrencyPipe
 *
 * Display formats:
 * - 'symbol' (default): Uses the currency symbol (e.g., USD → $, RON → RON)
 * - 'symbol-narrow': Uses narrow symbol variant (e.g., RON → lei, USD → $)
 * - 'code': Uses ISO currency code (e.g., USD, RON)
 *
 */
export const CURRENCY_DISPLAY_FORMATS: Record<string, 'symbol' | 'symbol-narrow' | 'code'> = {
  RON: 'symbol-narrow',
}

const ANGULAR_TO_INTL_DISPLAY_MAP = {
  'symbol-narrow': 'narrowSymbol',
  symbol: 'symbol',
  code: 'code',
} as const

export function getCurrencyDisplayFormat(currencyCode: string): 'symbol' | 'symbol-narrow' | 'code' | undefined {
  return CURRENCY_DISPLAY_FORMATS[currencyCode]
}

export function getIntlCurrencyDisplay(currencyCode: string): 'symbol' | 'narrowSymbol' | 'code' {
  const angularFormat = getCurrencyDisplayFormat(currencyCode)
  return angularFormat ? ANGULAR_TO_INTL_DISPLAY_MAP[angularFormat] : 'symbol'
}
